// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as VisibilityOffComponent} from './VisibilityOff.svg';

import Icon, { TIconProps } from '../Icon';

export const IconVisibilityOff = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <VisibilityOffComponent/>
  </Icon>
));
